<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="`${$t('common.add')} ${$t('hospital.hospital-exchange-rate')}`"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.value')" label-for="value">
              <b-form-input
                type="number"
                v-model="EditForm.value"
                :placeholder="$t('common.value')"
                @input="validateInput"
              />
              <p v-if="showWarning" class="text-danger mt-1">
                {{ $t('common.please-enter-a-number-between-1000-and-2000') }}
              </p>
              <p class="text-danger mt-1">{{ errorForm.value }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading || !isValid"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('hospital.hospital-exchange-rate')">
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2 v-if="!loading">
            {{ $t('hospital.current-exchange-rate') }} : {{ data[0].value }}
          </h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="
              $store.state.app.permissions.includes('store-hospitalExchangeRate')
            "
          >
            {{ $t('common.add') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(created_at)="data">
            <span style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">{{ data.item.created_at }}</span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="delete-hospitalExchangeRate"
                :noEdit="true"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Items</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getHospitalExchangeRate()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import permissionChecker from '@/mixins/permissionChecker';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import ActionsButtons from '@/components/common/ActionsButtons.vue';

export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    BCard,
    ActionsButtons,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
  },
  data() {
    return {
      take: 10,
      loading: false,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        value: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        value: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        { key: 'value', sortable: true, label: this.$t('common.value') },
        { key: 'created_at', sortable: true, label: this.$t('common.date') },
        // { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      showWarning: false
    };
  },
  computed: {
    isValid() {
      return this.EditForm.value >= 1000 && this.EditForm.value <= 2000;
    }
  },
  mounted() {
    this.getHospitalExchangeRate();
  },
  methods: {
    show() {
      this.createMode = true;
      this.EditForm = {
        value: '',
        _method: 'POST',
      };

      this.$bvModal.show('modal-edit');
    },

    async getHospitalExchangeRate() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/hospitalExchangeRate?page=${this.page}&take=${this.take}&sort=-created_at`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.data.forEach((item) => {
        item.value = parseFloat(item.value).toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      });

      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/hospitalExchangeRate/${this.deleteForm.id}`)
        .then((response) => {
          this.getHospitalExchangeRate();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.value = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.value) {
        count++;
        this.errorForm.value = "The value field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      (this.params.form = this.EditForm),
        (this.params.path = `/hospitalExchangeRate`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.getHospitalExchangeRate();
            this.$bvModal.hide("modal-edit");
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    validateInput() {
      this.showWarning = !this.isValid;
    }
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
